import { Header } from '../landing/Header'

export const CheckoutLayout = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="min-h-screen bg-off-white font-sans text-brand-dark">
            <Header />
            <main>{children}</main>
        </div>
    )
}
